import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { finalize } from 'rxjs/operators';
import { IOrder } from '../../../../model/interfaces/order';
import { OrderService } from '../../../../orders/order.service';

@Component({
    selector: 'order-total-pallet-dialog',
    templateUrl: './order-total-pallet-dialog.component.html',
    standalone: false
})
export class OrderTotalPalletDialogComponent {
    customerId: number;
    doubleClickIsDisabled = false;
    palletCount: number;

    @Input('order') order: IOrder;
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private notificationsService: NotificationsService,
        private orderService: OrderService,
    ) {}

    formSubmitted(ngForm: NgForm): void {
        const newPalletCount = Math.round(ngForm.form.value.palletCount as number);
        if (newPalletCount < 0) {
            this.notificationsService.error('Please enter a valid number.');
            return;
        }
        
        this.orderService.updateTotalPallet(this.order.Id, newPalletCount)
            .pipe(finalize(() => this.doubleClickIsDisabled = false))
            .subscribe({
                next: () => {
                    this.order.TotalPallet = newPalletCount;
                    this.notificationsService.success('Order Pallet Count Updated.');
                    this.close();
                }
            });
    }

    close(): void {
        this.onClose.emit();
    }
}
